






















import { AxiosResponse } from 'axios'
import { mapActions, mapMutations, mapState } from 'vuex'
import {
  SET_CLASSIFIED_PAID_INFO,
  MODIFY_ROW_PUBLIC
} from '~/store/modules/shared/classifieds/search/mutation-types'
import { CLASSIFIED_SEARCH_ACTIONS_NS } from '~/store/modules/shared/classifieds/search/actions/state'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { formatNumber } from '~/utils/number'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import PaidClassifiedService from '~/services/classified/paid/PaidClassifiedService'
import { defineComponent } from '~/utils/nuxt3-migration'
import { ciEye } from '~/icons/source/solid/eye'

export default defineComponent({
  components: { CConfirmationModal },
  props: {
    classifiedId: {
      type: Number,
      required: true
    },
    cost: {
      type: Number,
      required: true
    },
    upfrontCost: {
      type: Number,
      required: true
    },
    hasPaidUpfront: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    showPayConfirmModal: false
  }),
  computed: {
    ...mapState(CLASSIFIED_SEARCH_ACTIONS_NS, {
      actionPending: state => state.pending
    }),
    icons() {
      return {
        pay: ciEye
      }
    },
    formattedCost() {
      if (this.cost || this.cost === 0) {
        if (this.cost !== 0) {
          return formatNumber(this.cost)
        }
        return this.cost
      }
      return null
    },
    formattedUpfrontCost() {
      if (this.upfrontCost || this.upfrontCost === 0) {
        if (this.upfrontCost !== 0) {
          return formatNumber(this.upfrontCost)
        }
        return this.upfrontCost
      }
      return null
    },
    confirmText() {
      if (this.hasPaidUpfront) {
        return this.$tc(
          '{credits} credit will be charged from you account | {credits} credits will be charged from you account',
          this.cost,
          {
            credits: this.formattedCost
          }
        )
      } else {
        return this.$t('upfront_credits_will_be_charged', {
          credits: this.formattedCost,
          upfrontCost: this.formattedUpfrontCost
        })
      }
    }
  },
  methods: {
    ...mapActions(CLASSIFIED_SEARCH_ACTIONS_NS, {
      performAction: 'performAction'
    }),
    ...mapMutations(CLASSIFIED_SEARCH_NS, {
      setClassifiedPaidInfo: SET_CLASSIFIED_PAID_INFO,
      modifyRowPublic: MODIFY_ROW_PUBLIC
    }),
    payClicked(e) {
      e.stopPropagation()
      e.preventDefault()
      this.showPayConfirmModal = true
    },
    pay() {
      this.performAction({
        action: async () => {
          const paidClassifiedService = this.$dep(PaidClassifiedService)
          const body: AxiosResponse = await paidClassifiedService.pay(
            this.classifiedId
          )

          const paidInfo = body.data
          this.setClassifiedPaidInfo({
            classifiedId: this.classifiedId,
            paidInfo
          })

          this.modifyRowPublic({
            classifiedId: this.classifiedId
          })

          // reload user to get updated credits
          this.$store.dispatch(`${USER_NS}/loadUser`, {}, { root: true })

          // reload payments summary widget
          this.$store.dispatch(
            `${CLASSIFIED_SEARCH_NS}/loadPaidSummary`,
            {},
            { root: true }
          )

          this.$cache.reset()
          return body
        },
        classifiedId: this.classifiedId
      })
    }
  }
})
